export default __webpack_public_path__ + "static/media/new_bg.945500f5.svg";